import {
	useFeedbackCollectorActions,
	EntryKeys,
	type FeedbackCollectorProps,
} from '@atlassian/jira-feedback-collector';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';

import { useRouter } from '@atlassian/jira-router';

import { useTenantContext } from '@atlassian/jira-tenant-context-controller';

import { EOC_FEEDBACK_ENTRYPOINT_ID } from './constants';
import { messages } from './messages';

export const useEocFeedbackCollector = () => {
	const { formatMessage } = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const { openFeedbackCollector } = useFeedbackCollectorActions();
	const { isAdmin, isSiteAdmin, appEditions } = useTenantContext();
	const [
		{
			route: { name, path },
		},
	] = useRouter();

	return {
		openEocFeedbackCollector: (options?: Partial<FeedbackCollectorProps>) => {
			openFeedbackCollector({
				showTypeField: false,
				feedbackTitle: formatMessage(messages.modalTitle),
				summaryPlaceholder: formatMessage(messages.feedbackInputPlaceholder),
				// @ts-expect-error: Object literal may only specify known properties, and 'customTextAreaLabel' does not exist in type 'FeedbackCollectorProps'.ts(2345)
				customTextAreaLabel: formatMessage(messages.feedbackInputLabel),
				...options,
				entrypointId: EOC_FEEDBACK_ENTRYPOINT_ID,
				onSubmit: () => {
					// https://data-portal.internal.atlassian.com/analytics/registry/62661
					fireUIAnalytics(
						createAnalyticsEvent({
							actionSubject: 'eocFeedbackCollectorModal',
							action: 'submitted',
						}),
					);
				},
				feedbackContext: [
					{
						id: EntryKeys.IS_ADMIN,
						value: isAdmin,
					},
					{
						id: EntryKeys.IS_SITE_ADMIN,
						value: isSiteAdmin,
					},
					{
						id: EntryKeys.EDITION,
						value: appEditions.serviceDesk,
					},
					{
						id: EntryKeys.ROUTE_NAME,
						value: name,
					},
					{
						id: EntryKeys.LOCATION,
						value: path,
					},
				],
			});
		},
	};
};
